import React, { useRef } from 'react';
import { motion, useMotionValue, useSpring, useTransform } from 'framer-motion';
interface TiltCardProps {
  children: React.ReactNode;
  className?: string;
  intensity?: number; // higher = more tilt
  glare?: boolean;
}
/**
 * 3D mouse-tilt wrapper. Cards lift and tilt to follow the cursor,
 * met een subtiele glare-spotlight die de cursor volgt.
 */
export function TiltCard({
  children,
  className = '',
  intensity = 10,
  glare = true
}: TiltCardProps) {
  const ref = useRef<HTMLDivElement>(null);
  const mx = useMotionValue(0.5);
  const my = useMotionValue(0.5);
  const sx = useSpring(mx, {
    stiffness: 150,
    damping: 18
  });
  const sy = useSpring(my, {
    stiffness: 150,
    damping: 18
  });
  const rotateY = useTransform(sx, [0, 1], [-intensity, intensity]);
  const rotateX = useTransform(sy, [0, 1], [intensity, -intensity]);
  const glareX = useTransform(sx, [0, 1], ['0%', '100%']);
  const glareY = useTransform(sy, [0, 1], ['0%', '100%']);
  const glareOpacity = useSpring(useMotionValue(0), {
    stiffness: 200,
    damping: 20
  });
  function handleMove(e: React.MouseEvent<HTMLDivElement>) {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    mx.set((e.clientX - rect.left) / rect.width);
    my.set((e.clientY - rect.top) / rect.height);
    glareOpacity.set(0.5);
  }
  function handleLeave() {
    mx.set(0.5);
    my.set(0.5);
    glareOpacity.set(0);
  }
  return <motion.div ref={ref} onMouseMove={handleMove} onMouseLeave={handleLeave} className={`relative will-change-transform ${className}`} style={{
    rotateX,
    rotateY,
    transformStyle: 'preserve-3d',
    transformPerspective: 1000
  }} whileHover={{
    scale: 1.01
  }} transition={{
    scale: {
      type: 'spring',
      stiffness: 200,
      damping: 20
    }
  }} data-id="element-736">
      {children}
      {glare && <motion.div aria-hidden="true" className="absolute inset-0 rounded-[inherit] pointer-events-none mix-blend-overlay" style={{
      background: useTransform([glareX, glareY] as never, ([x, y]: string[]) => `radial-gradient(circle at ${x} ${y}, rgba(255,255,255,0.45) 0%, transparent 50%)`),
      opacity: glareOpacity
    }} data-id="element-737" />}
    </motion.div>;
}